import api from '@/lib/axios';
import { API_ENDPOINTS } from '@/constants/api-endpoints';

export type ShieldTransactionType = 'contribution' | 'withdrawal';

export interface ShieldLedger {
  id: string;
  balance: number;
  total_contributed: number;
  total_withdrawn: number;
  updated_at: string;
}

export interface ShieldTransaction {
  id: string;
  type: ShieldTransactionType;
  amount: number;
  balance_after: number;
  booking_id?: string;
  withdrawn_by?: string;
  notes?: string;
  created_at: string;
}

export interface ShieldTransactionsQuery {
  type?: ShieldTransactionType;
  page?: number;
  limit?: number;
}

export interface WithdrawPayload {
  amount: number;
  notes?: string;
}

export const shieldApi = {
  getBalance: async (): Promise<ShieldLedger> => {
    const res = await api.get(API_ENDPOINTS.ZIPTO_SHIELD.BALANCE);
    return (res.data as any)?.data ?? res.data;
  },

  getTransactions: async (
    query: ShieldTransactionsQuery = {},
  ): Promise<{ items: ShieldTransaction[]; total: number; page: number; pages: number }> => {
    const params: Record<string, unknown> = { page: query.page || 1, limit: query.limit || 30 };
    if (query.type) params.type = query.type;
    const res = await api.get(API_ENDPOINTS.ZIPTO_SHIELD.TRANSACTIONS, { params });
    return (res.data as any)?.data ?? res.data;
  },

  withdraw: async (payload: WithdrawPayload): Promise<{ balance: number }> => {
    const res = await api.post(API_ENDPOINTS.ZIPTO_SHIELD.WITHDRAW, payload);
    return (res.data as any)?.data ?? res.data;
  },
};